import React from 'react';
import { Card } from '@material-ui/core';

import TasksLedger from '../shared/TasksLedger';
import Content from '../../components/Content';

const TasksForTeamLedger = () => (
  <Content title="All tasks" maxWidth="lg">
    <Card>
      <TasksLedger
        url="/automatic/tasks-for-team/"
        httpLedgerProps={{
          isPaginated: true,
          isSearchable: true,
        }}
      />
    </Card>
  </Content>
);

export default TasksForTeamLedger;
